import React from 'react';

import { LogoImage } from './styles';

const DItemLogo = ({ src }: any) => {
    return <LogoImage src={src} />;
};

export default DItemLogo;
